export function maskValue(accessService, permission, value) {
  if (!value) return '';

  if (accessService.hasPermission(permission)) {
    return value;
  }

  return '•'.repeat(value.length);
}
